import { render, staticRenderFns } from "./FdrManual.vue?vue&type=template&id=10d534a8&scoped=true"
import script from "./FdrManual.vue?vue&type=script&lang=js"
export * from "./FdrManual.vue?vue&type=script&lang=js"
import style0 from "./FdrManual.vue?vue&type=style&index=0&id=10d534a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d534a8",
  null
  
)

export default component.exports